/**
 * No-role panel (§ role-gating / no_permission.tmpl). Rendered into #ksdm-content
 * (replacing the whole shell) when the user has no role_id. Centered message;
 * no rail, no table.
 */
const NoRolePanel = () => (
  <div className="no-permission">
    <div>
      <p>No role assigned!</p>
      <p>Contact your Administrator.</p>
    </div>
  </div>
);

export default NoRolePanel;
